<template>
    <v-dialog v-model="show" max-width="1255" height="651px" persistent>
        <!-- <template v-slot:activator="{ on }"> </template> -->
        <div class="modal">
            <v-card flat :loading="status === 'loading'">
                <div class="d-flex justify-space-between">
                    <v-btn
                            class="btn-blanco few mr-6"
                            @click="close"
                            style="width: 65px !important;font-weight: 700 !important;font-size: 35px;letter-spacing: 0.94px;position: absolute;border: medium none;right: -35px;"
                            :disabled="status === 'loading'"
                            :loading="status === 'loading'"
                    >X
                    </v-btn>
                </div>
                <v-row>
                    <div
                            class="icon-modal table-cell"
                            style="max-width: 240px !important;width: 240px !important;"
                    >
                        <v-layout class="align-center">
                            <v-flex style="margin-top: -113px;">
                                <img
                                        :src="require('@/assets/img/message.svg')"
                                        alt
                                        style="position: relative;top: -4px;left: -3px;"
                                />
                            </v-flex>
                        </v-layout>
                    </div>
                    <v-col class="table-cell modal-content modal-content-push">
                        <div class="content_cont_modal">
                            <v-form class="pt-1 pb-0" autocomplete="off">
                                <ValidationObserver ref="validator" v-slot="{}">
                                    <v-row>
                                        <v-col
                                                cols="8"
                                                class="content_push_notificatin"
                                                style="position: relative;top: -2px;left: 3px;"
                                        >
                                            <div class="d-flex justify-space-between">
                                                <h6 class="title_custom mb-5">
                                                    Push Notifications
                                                    Message
                                                </h6>
                                            </div>
                                            <p class="mb-2" style="position: relative;left: 3px;top: 1px;">
                                                <label class="label">Send to:</label>
                                            </p>
                                            <p class="">
                                                <span class="title_text"> {{total_contacts}} total contacts </span>
                                            </p>
                                            <div class="d-flex justify-space-between">
                                                <v-checkbox
                                                        v-model="vendors"
                                                        class="checkbox_options"
                                                        :label="`Vendors`"
                                                        @change="check()"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="agents"
                                                        :label="`Agents`"
                                                        class="checkbox_options"
                                                        @change="check()"
                                                ></v-checkbox>
                                                <v-checkbox
                                                        v-model="clients"
                                                        :label="`Homeowners`"
                                                        class="checkbox_options"
                                                        @change="check()"
                                                ></v-checkbox>
                                            </div>

                                            <p class="mb-2">
                                            </p>
                                            <p style="width: 555px;">
                                                <ValidationProvider
                                                        ref="push_title"
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                >
                                                    <v-text-field
                                                            v-model="title"
                                                            class="ui-label change_bord especial_border"
                                                            label="Title:"
                                                            name="push_title"
                                                            type="text"
                                                            width="660px"
                                                            required
                                                            counter
                                                            maxlength="35"
                                                            hint="Max Character"

                                                            :persistent-hint="persistentHint"
                                                            :error-messages="errors"
                                                    ></v-text-field>
                                                </ValidationProvider>
                                            </p>

                                            <div class="mt-6" style="width: 555px;">
                                                <label class="label">Text:</label>
                                                <ValidationProvider
                                                        ref="push_text"
                                                        rules="required"
                                                        v-slot="{ errors }"
                                                >
                                                    <v-textarea
                                                            v-model="text"
                                                            name="push_text"
                                                            auto-grow
                                                            outlined
                                                            rows="3"
                                                            row-height="25"
                                                            required
                                                            style="position: relative;top: 5px;"
                                                            id="text_area_push_notification"
                                                            class="ui-label custom-textarea change_bord"
                                                            counter
                                                            maxlength="120"
                                                            hint="Max Character"
                                                            @keyup="keymonitor()"
                                                            :persistent-hint="persistentHint"
                                                            :error-messages="errors"
                                                    ></v-textarea>
                                                </ValidationProvider>
                                            </div>

                                            <p
                                                    class="mt-10"
                                                    style="margin-bottom: 0px;line-height: 19px !important; color:#061d47 !important; font-weight: 700;font-size:16px !important;position: relative;top: 1px;left: 3px;"
                                            >
                                                When a homeowner clicks on the push notification, a chat will open with who?
                                            </p>
                                            <ValidationProvider
                                                    ref="push_user"
                                                    rules="required"
                                                    v-slot="{ errors }"
                                            >
                                                <v-autocomplete
                                                        :items="users"
                                                        v-model="selectedUser"
                                                        item-text="name"
                                                        item-value="owner_id"
                                                        class="label-custom mt-0 pt-0 custom-input-position-text change_bord especial_border custom-select-options"
                                                        name="push_user"
                                                        type="text"
                                                        placeholder="Select one user"
                                                        style="margin-right: 7px"
                                                        :multiple="false"
                                                        :disabled="status === 'loading'"
                                                        :readonly="status === 'loading'"
                                                        :error-messages="errors"
                                                >
                                                    <template v-slot:append>
                                                        <img :src="require('@/assets/img/dropdown-blue.svg')" alt/>
                                                    </template>
                                                </v-autocomplete>
                                                <p style="margin-bottom: 0px;line-height: 19px !important; color:#061d47 !important; font-weight: 700;font-size:12px !important;position: relative;top: 1px;left: 3px;"
                                                >
                                                    *Please note: <br>
                                                    - The user selected will not receive the push notification <br>
                                                    - A homeowner will always open a chat with its own agent, despite if you select a different agent above
                                                </p>
                                            </ValidationProvider>
                                            <!--<v-divider class="mt-11" style="position: relative;top: -10px;"></v-divider>-->

                                            <div style="margin-top: 13px;" class="d-flex buttons-option">
                                                <v-btn
                                                        class="btn-blanco few mr-6"
                                                        rounded
                                                        depressed
                                                        @click="close"
                                                        style="width:161px !important;font-weight: 700 !important;font-size: 15px;letter-spacing: 0.94px;"
                                                        :disabled="status === 'loading'"
                                                        :loading="status === 'loading'"
                                                >CANCEL
                                                </v-btn>
                                                <v-btn
                                                        class="btn-azul few "
                                                        rounded
                                                        depressed
                                                        @click="submit"
                                                        style="width:161px !important;position: relative;left: -16px;font-weight: 700 !important;font-size: 15px;letter-spacing: 0.94px;"
                                                        :disabled="status === 'loading'"
                                                        :loading="status === 'loading'"
                                                >SEND
                                                </v-btn>
                                            </div>
                                        </v-col>
                                        <v-col cols="4" class="imagen_movil"
                                               style="position: relative;top: -3px;left: -2px;">
                                            <span class="title_push">
                                                {{title}}
                                            </span>
                                            <span class="text_push">
                                                {{text}}
                                            </span>
                                            <img class="d-block" :src="require('@/assets/movil.png')" alt="movil app"/>
                                        </v-col>
                                    </v-row>
                                </ValidationObserver>
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </v-dialog>
</template>

<script>
    import {mapState, mapActions} from "vuex";
    import {ValidationProvider, ValidationObserver} from "vee-validate";

    export default {
        props: ["show", "hide", "click"],
        created() {
            this.get_tenant().then((response) => {
                if (response === 'success') {
                    this.retrieve_receptors();
                    this.retrieve_users();
                }
            });
        },
        data: () => ({
            persistentHint: true,
            title: "",
            text: "",
            vendors:false,
            agents:false,
            clients:false,
            total_contacts: 0,
            image: require("@/assets/logo.svg"),
            selectedUser: null,
            valid: false
        }),
        computed: {
            ...
                mapState({
                    status: state => state.Push_notifications.status,
                    total_receptors: state => state.Push_notifications.total_receptors,
                    total_agents: state => state.Push_notifications.total_agents,
                    total_clients: state => state.Push_notifications.total_clients,
                    total_vendors: state => state.Push_notifications.total_vendors,
                    users: state => state.Push_notifications.users,
                })
        }
        ,
        components: {
            ValidationProvider,
            ValidationObserver,
        }
        ,
        methods: {
            ...
                mapActions({
                    get_tenant: "Push_notifications/get_tenant",
                    retrieve_receptors: "Push_notifications/retrieve_receptors",
                    retrieve_users: "Push_notifications/retrieve_users",
                }),
            keymonitor() {

            },
            close:

                function () {
                    this.hide();
                }

            ,
            async submit() {
                const self = this;
                self.valid = await
                    this.$refs.validator.validate();
                if (self.valid) {
                    const index = self.users.findIndex(a => a.owner_id === self.selectedUser);
                    await
                        this.$store.commit("Push_notifications/save_notification", {
                            title: self.title,
                            text: self.text,
                            vendors: self.vendors,
                            agents: self.agents,
                            clients: self.clients,
                            total_contacts: self.total_contacts,
                            user: self.users[index]
                        });
                    self.click();
                }
            },
            check: function() {
                let total = 0;
                if (this.vendors || this.agents || this.clients){
                    total = 0;
                    if (this.vendors){
                        total = total + this.total_vendors;
                    }
                    if (this.agents){
                        total = total + this.total_agents;
                    }
                    if (this.clients){
                        total = total + this.total_clients;
                    }
                }else{
                    total = 0;
                }
                this.total_contacts = total;
            }
        }
    }
    ;
</script>
<style scoped>
    .custom-textarea .v-input__control {
        background-color: maroon;
    }

    .title_custom {
        color: #041332 !important;
        font-size: 30px !important;
        font-weight: 500 !important;
        line-height: 34px !important;
        font-family: "Roboto-Medium" !important;
    }

    .push_notification {
        width: 1255px !important;
        max-width: 1255px !important;
        height: 651px !important;
    }

    .imagen_movil img {
        margin-top: 58px;
        margin-left: 11px;
        width: 271px;
        height: 533px;
    }

    .content_push_notificatin {
        padding: 15px 50px 0 30px;
    }

    .title_text {
        color: #3256a4;
        font-size: 18px;
        font-weight: 400;
    }

    .title_text_one {
        color: #717e91;
        font-size: 14px;
        font-weight: 400;
        line-height: 15px;
        margin-left: 14px;
    }

    @media screen and (max-width: 990px) {
        .content_push_notificatin {
            padding: 0px !important;
        }

        .push_notification {
            width: 100% !important;
            height: auto;
        }

        .content_push_notificatin {
            max-width: 100% !important;
            padding-right: 0;
        }
    }

    @media screen and (max-width: 790px) {
        .imagen_movil {
            display: none;
        }
    }

    @media screen and (max-width: 600px) {
        .title_custom {
            font-size: 25px !important;
        }

        .title_text {
            font-size: 13px !important;
        }
    }
</style>
